import React from 'react';
import Typography from '@src/new-components/Typography';
import { Box, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import RecordVoiceOverRoundedIcon from '@mui/icons-material/RecordVoiceOverRounded';
import SettingsVoiceRoundedIcon from '@mui/icons-material/SettingsVoiceRounded';
import HearingDisabledRoundedIcon from '@mui/icons-material/HearingDisabledRounded';
import CloseIcon from '@mui/icons-material/Close';
import CardGuideItem from '../CardGuideItem';
import { TipList, Title } from './index.style';

const GUIDES = [
  {
    title: 'avoidNoisyEnvironments',
    description: 'avoidNoisyEnvironmentsDesc',
    icon: <HearingDisabledRoundedIcon sx={{ color: COLOR.darkBlue }} />,
  },
  {
    title: 'checkMicrophoneQuality',
    description: 'checkMicrophoneQualityDesc',
    icon: <SettingsVoiceRoundedIcon sx={{ color: COLOR.darkBlue }} />,
  },
  {
    title: 'oneVoiceOnly',
    description: 'oneVoiceOnlyDesc',
    icon: <RecordVoiceOverRoundedIcon sx={{ color: COLOR.darkBlue }} />,
  },
];

const Header = ({ closePopupInstantVoiceCloning }) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Title>
        <Typography
          component="p"
          color="#1C1C1E"
          variant="body-24-bold"
          gutterBottom
        >
          {t('instantVoiceClone')}
        </Typography>

        <IconButton onClick={closePopupInstantVoiceCloning} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Title>

      <TipList>
        {GUIDES.map((guide) => (
          <CardGuideItem
            key={guide.title}
            icon={guide.icon}
            title={t(guide.title)}
            description={t(guide.description)}
          />
        ))}
      </TipList>
    </Box>
  );
};
export default Header;
